import React, { useCallback, useState } from "react"
import _ from "lodash"

import "./Sandbox.scss"

const ContentRow: React.FC<React.PropsWithChildren<{className?: string}>> = ({children, className}) => {
  return (
    <div className={className} style={{margin: "1em 0"}}>
      {children}
    </div>
  )
}

export const Section: React.FC<React.PropsWithChildren<{title?: string}>> = ({children, title}) => {
  return (
    <div className="sandbox__section">
      {title && <h2 className="sandbox__section__title"><span>{title}</span></h2>}
      {children}
    </div>
  )
}

export const Block: React.FC<React.PropsWithChildren<{className?: string, dark?: boolean, framed?: boolean}>> = ({ className: passedClassName, children, dark, framed }) => {
  const className = [
    "sandbox__block",
    dark ? "sandbox__contentRow--dark" : "",
    passedClassName || "",
    framed ? "sandbox__block--framed" : ""
  ].join(" ")
  return <ContentRow className={className}>{children}</ContentRow>
}

export const Note: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <div className="sandbox__note">
      {children}
    </div>
  )
}

// ------------ Collect all [Name].sandbox.tsx ------------
type SandboxListing = [string, React.ReactNode]
let sandboxes: SandboxListing[] = []
;(() => {
  const sandboxFilesContext = require.context("../../", true, /\.sandbox\.tsx$/)
  sandboxFilesContext.keys().forEach((key) => {
    const name: string = key.split("/")[key.split("/").length - 1].split(".sandbox.tsx")[0]
    const Comp: React.ReactNode = sandboxFilesContext(key).default
    sandboxes.push([name, Comp])
  })
})()
sandboxes = _.sortBy(sandboxes, 0)

const Sandbox: React.FC = () => {
  const [ pageInfo, __setPageInfo ] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    let page = -1
    let subpage = 0
    try {
      if (params.get("page")) {
        page = parseInt(params.get("page")!)
      }      
    } catch {
      // ignore
    }
    try {
      if (params.get("subpage")) {
        subpage = parseInt(params.get("subpage")!)
      }      
    } catch {
      // ignore
    }
    return {
      activeSandboxIndex: page,
      subpage,
    }
  })
  const setPageInfo = useCallback((pageIndex: number, subpage?: number) => {
    const newInfo: (typeof pageInfo) = { activeSandboxIndex: pageIndex, subpage: subpage ?? 0 }

    const params = new URLSearchParams()
    params.set("page", `${pageIndex}`)
    if (typeof subpage === "number") { params.set("subpage", `${subpage}`) }
    window.history.replaceState(null, "", `?${params.toString()}`)

    __setPageInfo(newInfo)
  }, [])

  
  const [ isSelectorVisible, setIsSelectorVisible ] = useState(false)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Comp: any = pageInfo.activeSandboxIndex > -1
    ? sandboxes[pageInfo.activeSandboxIndex][1]
    : null

  return (
    <div className="neo__app">
      <div className="sandbox__head">
        <div
          className={`sandbox__selector ${isSelectorVisible ? "sandbox__selector--visible" : ""}`}
          onMouseEnter={() => setIsSelectorVisible(true)}
          onMouseLeave={() => setIsSelectorVisible(false)}
          >
          <div className="sandbox__selector__toggler"
            onTouchStart={() => setIsSelectorVisible(!isSelectorVisible)}
          >↴</div>
          <ul>
            {_.map(sandboxes, ([name], index) => {
              const current = index === pageInfo.activeSandboxIndex
              return <li
                key={`sandbox${index}`}
                style={current ? { fontWeight: "bold" } : {}}
                onClick={() => setPageInfo(index)}>
                {name}</li>
            })}
          </ul>
        </div>
        <h1>
          Sandbox
          {Comp && <>{" ❯ "}<span>{sandboxes[pageInfo.activeSandboxIndex][0]}</span></>}
        </h1>
      </div>
      <div className="sandbox__body">
        {Comp && <Comp subPage={pageInfo.subpage} setSubPage={(subpage: number) => setPageInfo(pageInfo.activeSandboxIndex, subpage)} />}
      </div>
    </div>
  )
}

export default Sandbox
